import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { Wrapper } from "../Categories/SubCategories/styles";

const LoaderItem = styled.div`
    border-radius: 12px;
    border: 1px solid #CDE2FC;
    padding: 16px 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
`;

export const SubCategoriesLoader = ({ count = 3, ...props }) => {
  return (
    <Wrapper { ...props }>
      {Array.from({ length: count }).map((_, index) => (
        <LoaderItem key={index}>
          <ContentLoader
            viewBox="0 0 1000 200"
            height="50"
            width="100%"
            speed={2}
          >
            <rect x="0" y="50" rx="4" ry="4" width="100" height="100" />
            <rect x="140" y="50" rx="3" ry="3" width="650" height="40" />
            <rect x="140" y="110" rx="3" ry="3" width="300" height="30" />
          </ContentLoader>
        </LoaderItem>
      ))}
    </Wrapper>
  );
};
